export default function (string, uppercaseFirstLetter = false) {
  return string
    .replace(/^([a-zA-Z])/, ($1) => (uppercaseFirstLetter ? $1.toUpperCase() : $1.toLowerCase()))
    .replace(/[- ]/g, '_')
    .replace(/(_[a-z])/g, ($1) => `_${$1.toUpperCase()}`)
    .replace(/_+/g, '');
}
